import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchUnfulfilledAdsOver20HoursProps = { startDate: Moment; endDate: Moment };

export type FetchUnfulfilledAdsOver20Hours = (
  dates: FetchUnfulfilledAdsOver20HoursProps,
) => void;

const fetchUnfulfilledAdsOver20Hours = ({
  startDate,
  endDate,
}: FetchUnfulfilledAdsOver20HoursProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("unfulfilled_ads_over_20_hours", dispatch, params);
};

export default fetchUnfulfilledAdsOver20Hours;
